export default "__VITE_ASSET__15c691be__"